export const mutations = {
  updateToken (state, token) {
      state.token = token
  },

  UpdateSerieses (state, newValue) {
      state.seriesesInState = newValue
  },

  SetCurrentCourse (state, newValue) {
    // console.log('mutation.js > SetCurrentCourse')

    state.currentCourse = newValue
  },

  updateSeriesesJsonRequestStatus (state, newValue) {
    state.requestSeriesesJson = newValue
  },

  updateSeriesesJsonExpireTimer (state, newValue) {
    state.requestSeriesesJsonExpire = newValue
  },

  UpdateSeriesesFiles (state, payload) {
    state.seriesesFiles = payload
  },

  UpdateSeriesesFilesLoading (state, payload) {
    state.seriesesFilesLoading = payload
  }
}



// WEBPACK FOOTER //
// ./src/vuex/mutations.js